module.exports = __webpack_public_path__ + "img/Art.59843e7c.webp";